import { Trans } from 'react-i18next'
import styled from 'styled-components'

import { useTranslation } from '@root/shared/localization'
import { Separator } from '@root/shared/ui-kit'

import type { ClassNameProps } from '@root/shared/react'

type Props = {
  withLabel?: boolean
} & ClassNameProps

export const ReferralPointsInfo = ({ withLabel, className }: Props) => {
  const { t } = useTranslation()

  return (
    <Root className={className}>
      {withLabel ? <Label>{t('referral.points-info.label')}</Label> : undefined}
      <Points>
        <Point>
          <Trans i18nKey="referral.point1" components={[<strong key={0} />]} />
        </Point>
        <Separator variant="solid" vertical />
        <Point>
          <Trans i18nKey="referral.point2" components={[<strong key={0} />]} />
        </Point>
        <Separator variant="solid" vertical />
        <Point>
          <Trans i18nKey="referral.point3" components={[<strong key={0} />]} />
        </Point>
      </Points>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  gap: 12px;
`

const Label = styled.div`
  color: var(--textA-11);
  text-align: center;

  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`

const Points = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr auto 1fr;
  gap: 14px;
  padding: 0 8px;
  color: var(--textA-4);
`

const Point = styled.div`
  color: var(--textA-9);
  font-weight: 500;
  font-size: 11px;
  line-height: 16px;
  text-align: center;

  strong {
    color: var(--primary-9);
  }
`
